import Service from 'react-reservice';

export interface IAccountServiceContext {
  oneClickTradingLoading?: boolean;
  isOneClickTradingEnabled?: boolean;
}

const defaultContext: IAccountServiceContext = {
  oneClickTradingLoading: true
};

class AccountService extends Service<IAccountServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  getIsOneClickTradingEnabled = () => {
    return this.context.isOneClickTradingEnabled;
  };

  setOneClickTradingLoading = (loading: boolean) => {
    this.context.oneClickTradingLoading = loading;
  };

  setIsOneClickTradingEnabled = (nextOneClickTradingEnabled: boolean) => {
    this.context.isOneClickTradingEnabled = nextOneClickTradingEnabled;
  };
}

export const accountService = new AccountService();
